<template>
  <div>
    <div id="popupBackground">
      <div @click="onDialogClose" id="triggerClick" aria-hidden="true"></div>
      <vx-card ref="dialog" role="dialog" aria-modal="true" :aria-label="title" id="videoPopup">
        <div tabindex="0" data-focus-sentinel @focus="focusLastInDialog"></div>
        <button
          type="button"
          class="no-style close-icon-button"
          :aria-label="'Close ' + title"
          @click="onDialogClose"
        >
          <span class="ml-4 feather-icon select-none close-icon" aria-hidden="true"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line></svg
          ></span>
        </button>
        <div class="video-responsive">
          <iframe :src="videoCode" :title="title" frameborder="0" allowfullscreen></iframe>
        </div>
        <div tabindex="0" data-focus-sentinel @focus="focusFirstInDialog"></div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import dialogMixin from '@/mixins/dialog';

export default {
  mixins: [dialogMixin],
  props: {
    videoCode: {
      type: String,
      required: true,
    },
    // Accessible name for the embed (WCAG SC 4.1.2). Pass the video's actual name.
    title: {
      type: String,
      default: 'YouTube video player',
    },
  },
  inject: ['closePopup'],
  methods: {
    onDialogClose() {
      this.closePopup();
    },
  },
};
</script>
<style scoped>
#videoPopup {
  position: fixed;
  top: 10%;
  width: 60%;
  left: 20%;
}
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
#popupBackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
#popupBackground #triggerClick {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.close-icon {
  width: 15px;
  float: right;
  margin-bottom: 5px;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  #videoPopup {
    top: 10%;
    width: 94%;
    left: 3%;
  }
}
</style>
